import { render, staticRenderFns } from "./lazada.vue?vue&type=template&id=7803ea9a&scoped=true"
import script from "./lazada.vue?vue&type=script&lang=js"
export * from "./lazada.vue?vue&type=script&lang=js"
import style0 from "./lazada.vue?vue&type=style&index=0&id=7803ea9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803ea9a",
  null
  
)

export default component.exports